module.exports = __webpack_public_path__ + "img/wx.ff5eeb88.png";